import React from "react";
import "./BattleConfirmationDialog.css";

const BattleConfirmationDialog = ({ secondsLeft, confirmed, onConfirm, onExit, onClose }) => (
  <div className="battle-confirmation-overlay" role="presentation">
    <section className="battle-confirmation-dialog" role="dialog" aria-modal="true" aria-labelledby="battle-confirmation-title">
      <button type="button" className="battle-confirmation-close" aria-label="Close battle confirmation" onClick={onClose}>
        <i className="bi bi-x-lg" aria-hidden="true" />
      </button>
      <div className="battle-confirmation-icon"><i className="bi bi-lightning-charge-fill" aria-hidden="true" /></div>
      <h2 id="battle-confirmation-title">Are you ready for battle?</h2>
      <div className="battle-confirmation-countdown" aria-label={`${secondsLeft} seconds remaining`}>{secondsLeft}</div>
      <p>Confirm before the countdown ends to join the battle.</p>
      <p className="battle-confirmation-instructions">Choose your answers before the question timer runs out. Your score will update as you play.</p>
      {confirmed ? <strong className="battle-confirmation-ready">Ready! Waiting for the battle to begin...</strong> : (
        <div className="battle-confirmation-actions">
          <button type="button" className="battle-confirmation-yes" onClick={onConfirm}>Yes</button>
          <button type="button" className="battle-confirmation-exit" onClick={onExit}>Exit Battle</button>
        </div>
      )}
    </section>
  </div>
);

export default BattleConfirmationDialog;
